import axios from 'axios'
import qs from 'qs'
import { handleCookies } from '@/helpers'
import { Toast } from 'buefy/dist/components/toast'
import { Snackbar } from 'buefy/dist/components/snackbar'
import uuid from 'uuid'


//____________________________________________________________________________________ Service root path definitions _//

let protocol = window.location.protocol;
//let protocol = 'https:';
let hostname = window.location.hostname.replace('www.', '');

let apiPath = 'api.iskolig.com/in/v1'; //Default root path
let tokenPath = 'token.iskolig.com';

// Domain groups
let domainGroups = {
  test: [
    "localhost",
    "test.iskolig.com"
  ],
  stage: [
    "stage.iskolig.com"
  ],
  prod: [
    "data.iskolig.com"
  ]
};


//API paths
let apiDomains = {
  test: "api.iskolig.com/in/v1",
  stage: "stage-api.iskolig.com/in/v1",
  prod: "api.iskolig.com/in/v1"
};

let tokenDomains = {
  test: "token.iskolig.com",
  stage: "stage-token.iskolig.com",
  prod: "token.iskolig.com"
};

// Determine domain by current host.
// _.each(domainGroups, function (domainGroup, groupName) {
//
//   // Check if domain group includes current domain.
//   if (_.includes(domainGroup, hostname)) {
//     apiPath = apiDomains[groupName];
//     tokenPath = tokenDomains[groupName];
//   }
//
// });

Object.entries(domainGroups).forEach(([groupName, domainGroup]) => {
    if (domainGroup.includes(hostname)) {
        apiPath = apiDomains[groupName];
        tokenPath = tokenDomains[groupName];
    }
});

//Set base api path
let baseUrl = `${protocol}//${apiPath}`;
let tokenUrl = `${protocol}//${tokenPath}`;

// //Set base api path
// let baseUrl = process.env.VUE_APP_API_PATH;
// let tokenUrl = process.env.VUE_APP_TOKEN_PATH;

//_________________________________________________________________________________________________________ Token Service Create  _//

export const TokenService = axios.create({
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept-Language': 'tr-TR'
    }
});

//_________________________________________________________________________________________________________ SessionId _//

let uuidV4 = uuid.v4();

if (!localStorage || !localStorage.SID)
    localStorage.setItem('SID', JSON.stringify(uuidV4))

if (localStorage.SID)
    uuidV4 = JSON.parse(localStorage.SID)

//_________________________________________________________________________________________________________ Defaults _//

axios.defaults.baseURL = baseUrl;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept-Language'] = 'tr-TR';

//_____________________________________________________________________________________________ Response interceptor _//

axios.interceptors.response.use(
    (response) => {
        return Promise.resolve(response)
    }, (error) => {

        // header right top error message close
        if (error.config.errorMessage === false && error.response.status === 400) {
            return false;
        }

        if (error.response.data && error.response.data.errors) {

            for (let i = 0; i < error.response.data.errors.length; i++) {
                Toast.open({message: `${error.response.data.errors[i].errorMessage}`, type: 'is-danger', position:'is-bottom-right', duration: 4000})
            }
        }


        // 401 config
        const originalRequest = error.config

        // 401 token control

        if (error.response.status === 401 && !originalRequest._retry) {

            // originalRequest retry
            originalRequest._retry = true;

            return refreshToken().then(function (response) {

                // token delete and refresh
                handleCookies.deleteCookie('token');
                handleCookies.setCookie({token: response.data.access_token});

                //set axios.default headers token value
                axios.defaults.headers['Authorization'] = `Bearer ${response.data.access_token}`;
                // Config token
                originalRequest.headers['Authorization'] = `Bearer ${response.data.access_token}`;

                // Retry services
                return axios(originalRequest);
            })

        }

        // request is rejected and will direct logic to the catch() method
        return Promise.reject(error)
    });

//______________________________________________________________________________________________ Request interceptor _//

axios.interceptors.request.use(
    (config) => {

        // source type headers add
        config.headers['Source-Type'] = 1;
        config.headers['SID'] = uuidV4;

        delete config.headers.Authorization; //remove token
        //get token cookie
        let token = handleCookies.getCookie('token');
        //if token exists, set headers
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        return config;
    }, (error) => {

        return Promise.reject(error);
    });


TokenService.interceptors.request.use(
    (config) => {
        delete config.headers.Authorization; //remove token
        return config
    }, (error) => {
        return Promise.reject(error);
    });


TokenService.interceptors.response.use(
    (response) => {
        return Promise.resolve(response)
    }, (error) => {

        if (error.response.status === 400) {

            //TODO
            // Invalid grant type control
            //

            Snackbar.open({
                message: 'Kariyer.net ile üye girişi yapmalısınız.',
                type: 'is-danger',
                position: 'is-bottom-right',
                actionText: 'Giriş yap',
                indefinite: true,
                onAction: () => {
                    window.location.href = 'https://www.kariyer.net/website/kariyerim/login.aspx'
                }
            })

            // invalid grand type redirect to login page
            handleCookies.deleteCookie('token');
            //handleCookies.deleteCookie('guid');
            //handleCookies.deleteCookie('number');
            //index.push({name: 'LoginView'});

        }

        return Promise.reject(error)
    });

//____________________________________________________________________________________________________ Service Paths _//
export const serviceConfigs = {
    common:{
        root: 'api',
        step:{
            type: 'get',
            path: 'step/all'
        }
    },
    user: {
        root: 'api/users',
        interview: {
            type: 'get',
            path: 'interviews'
        },
        salary: {
            type: 'get',
            path: 'salary'
        },
    },
    salary: {
        root: 'api/salary',
        add: {
            type: 'post',
            path: 'add'
        },
        range: {
            type:'get',
            path:'positions/ranges'
        }
    },
    interview: {
        root: 'api/interview',
        interview:{
            path: '',
            type:'put'
        },
        predefined: {
            type:'get',
            path:'predefined'
        },
        add: {
            type:'post',
            path:'add'
        }
    },
    company:{
        root: 'api/company',
        search: {
            type: 'get',
            path: 'search'
        }
    },
    position:{
        root: 'api/positions',
        search: {
            type: 'get',
            path: 'search'
        }
    },
    city:{
        root: 'api/city',
        search: {
            type: 'get',
            path: 'search'
        }
    },
    settings:{
        root: 'api/settings',
        recaptchas: {
            type: 'get',
            path: 'recaptchas'
        }
    }
};

//__________________________________________________________________________________________________ Axios Instances _//

export let serviceWrapper = (serviceGroupObj, servicePathObj, params, headers) => {

    //set service path
    let path = `${baseUrl}/${serviceGroupObj['root']}/${servicePathObj['path']}`;

    // common api type path
    if (servicePathObj['apiType'] === 'common') {
        path = `${baseUrl.replace('ats', 'common')}/${serviceGroupObj['root']}/${servicePathObj['path']}`;
    }

    //set querystring params if type is GET
    if (params && servicePathObj['type'] == 'get') {

        let paramArr = [];

        for (let prop in params) {
            if (params.hasOwnProperty(prop)) {
                let propValue = `${prop}=${params[prop]}`;
                paramArr.push(propValue);
            }
        }

        for (let i = 0; i < paramArr.length; i++) {
            if (i == 0) {
                path += `?${paramArr[i]}`;
            } else {
                path += `&${paramArr[i]}`;
            }
        }
    }

    for (let prop in headers) {
        if (headers.hasOwnProperty(prop)) {
            axios.defaults.headers[`${prop}`] = headers[prop]
        }
    }

    return axios[servicePathObj['type']](path, params, headers)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return Promise.reject(error)
        });
};

export const getToken = () => {

    let tokenDomain = tokenUrl;
    let tokenParams = {
        client_type: 4,
        grant_type: 'password',
        client_id: 'IskoligPublicUser',
        client_secret: 'c713418e-6e43-4252-974d-bf678b6bd5ea',
    };

    //if (sessionStorage && sessionStorage.knetToken) tokenParams.otherToken = JSON.parse(sessionStorage.knetToken)

    tokenParams.otherToken = "";

    return TokenService.post(tokenDomain + '/api/token', qs.stringify(tokenParams));
}

export const refreshToken = () => {
    return getToken();
};

export default {
    serviceConfigs: serviceConfigs,
    serviceWrapper: serviceWrapper,
    getToken: getToken,
    refreshToken: refreshToken
}
